import {
  CREATE_ORGANISATION_URL,
  DELETE_ORGANISATION_URL,
  GET_ALL_ORGANISATIONS_URL,
  UPDATE_ORGANISATION_URL,
} from 'constants/apiConstants';
import {
  ICreateOrganisationRequest,
  IOrganisation,
  IUpdateOrganisationRequest,
} from 'interfaces/IOrganisations';
import axiosInstance from 'services/AxiosInstance';
import { resolveApiPath } from 'utils/UtilityMethods';

export const OrganisationsService = {
  FetchAllOrganisations: async (): Promise<IOrganisation[]> => {
    const response = await axiosInstance.get(GET_ALL_ORGANISATIONS_URL, {
      _silentErrors: true,
    });
    return response.data;
  },

  CreateOrganisation: async (
    payload: ICreateOrganisationRequest
  ): Promise<IOrganisation> => {
    const response = await axiosInstance.post(CREATE_ORGANISATION_URL, payload);
    return response.data;
  },

  UpdateOrganisation: async (
    payload: IUpdateOrganisationRequest
  ): Promise<IOrganisation> => {
    const response = await axiosInstance.put(UPDATE_ORGANISATION_URL, payload);
    return response.data;
  },

  DeleteOrganisation: async (id: string): Promise<void> => {
    await axiosInstance.delete(resolveApiPath(DELETE_ORGANISATION_URL, { id }));
  },
};

export default OrganisationsService;
